@if (application._Ebb_LdpId) {
  <div>
    <span style="font-size: 15px; font-weight: 500;">
      {{ taskRetrofitLdpSummary }}
    </span>
    @if (retrofitLdp) {
      <div>
        <span class="retrofit-task-business-info">
          Email: {{ retrofitLdp.emailAddress2?retrofitLdp.emailAddress2:retrofitLdp.emailAddress1 }}
        </span>
        <span class="retrofit-task-business-info">
          Phone: {{ this.utilityService.formatPhone(retrofitLdp.address2_Telephone1) }}
        </span>
      </div>
    }
    <br>
      @if (isAuthorizedAndRequiredBid()) {
        <mat-card appearance="outlined">
          <h6>DESIGN PROFESSIONAL ESTIMATE</h6>
          @if (isAuthorizedAndRequiredBid()) {
            <div style="display: flex; flex-direction: column; gap: 12px; margin-top: 28px;">
              <div style="display: flex; flex-wrap: wrap; gap: 12px; align-items: center;">
                <button (click)="onSubmitBidEvent('1stBid')" mat-stroked-button color="primary">
                  {{ displayFirstBidLabel }}
                </button>
                @if (isSecondBidVisible && !isSecondBidEditMode) {
                  <button
                    (click)="onLdp2ndUnlistedEvent()"
                    mat-stroked-button
                    color="primary">
                    SUBMIT SECOND ESTIMATE
                  </button>
                }
                @if (isSecondBidVisible && isSecondBidEditMode) {
                  <button
                    (click)="onSubmitBidEvent('2ndBidEdit')"
                    mat-stroked-button
                    color="primary">
                    EDIT SECOND ESTIMATE
                  </button>
                }
              </div>
            </div>
          }
          @if (bid1rejected) {
            <div style="white-space: normal;">
              <span class="warn-text">
                Action required
              </span>
              <span style="white-space:nowrap;">
                (<a style='color: #29637C; font-size: 16px; font-weight: 400;'
                href="javascript:void(0)"
              (click)='onClickShowReasonWhy(bid1rejectedwhy)'>read why</a>)
            </span>
          </div>
        }
      </mat-card>
    }
    <br>
      @if (saveBidProgressIndicator) {
        <div style="margin-top: 12px; display: flex; justify-content: center;">
          <mat-progress-bar mode="indeterminate" style="width: 300px;"></mat-progress-bar>
        </div>
      }
      @if (checkUploadAuthorization() === 3) {
        <div
          style="margin-top: 12px;">
          <a href="javascript:void(0)"
            matTooltip="Click for more actions..."
            class="retrofit-task-inline-action-link"
            style="width: 175px; margin-top: 5px;"
            [matTooltipPosition]="'below'"
            [matMenuTriggerFor]="menuLdpMoreActions">
            <mat-icon style="font-size: 13px;">more_vert</mat-icon>
            <span style="position: absolute; margin-left: -6px; margin-top: -1px;">
              MORE ACTIONS
            </span>
            <mat-menu #menuLdpMoreActions='matMenu'>
              <button mat-menu-item
                (click)="onLdpUnlistedEvent()">
                <mat-icon>
                  edit
                </mat-icon>
                <span>
                  CHANGE DESIGN PROFESSIONAL
                </span>
              </button>
            </mat-menu>
          </a>
        </div>
      }
    </div>
  } @else {
    <div ngif="selectretrofitLdp">
      <div>
        <p class="retrofit-task-item-title">
          <span>
            <!-- Select who will be creating the engineered plan. -->
            Add a Design Professional and Upload estimate.
          </span>
        </p>
        <div style="margin-top: 12px;">
          <button mat-stroked-button color="primary" (click)="onLdpUnlistedEvent()">
            ADD DESIGN PROFESSIONAL
          </button>
        </div>
      </div>
    </div>
  }
